export const rewardsKeys = {
  all: ["rewards"] as const,
  vendors: () => [...rewardsKeys.all, "vendor"] as const,
  vendor: (vendorCode: string) =>
    [...rewardsKeys.vendors(), vendorCode] as const,
  fulfillmentChannels: (vendorCode: string) =>
    [...rewardsKeys.vendor(vendorCode), "fulfillmentChannel"] as const,

  fulfillmentChannel: (vendorCode: string, fulfillmentChannel: string) =>
    [
      ...rewardsKeys.fulfillmentChannels(vendorCode),
      fulfillmentChannel,
    ] as const,
  availablePromos: () => [...rewardsKeys.all, "availablePromos"] as const,
  promoReasons: () => [...rewardsKeys.all, "promoReasons"] as const,
}
